import React from 'react';
import styled from 'styled-components';
import { Grid, Paper, Typography, List, ListItem } from '@material-ui/core';

import { PageWrapper } from '../../../components';
import { paragraphs, buyerTerms, sellerTerms } from './terms';

const StyledSection = styled(Paper)`
  && {
    max-width: 856px;
    border-radius: 0;
    margin: 24px auto 0;
    padding: 32px 110px 48px 110px;
    @media (max-width: 960px) {
      padding: 32px;
    }
    @media (max-width: 600px) {
      padding: 16px;
    }
  }
`;

const StyledTitle = styled(Typography)`
  && {
    font-size: 32px;
    margin: 40px 0;
    @media (max-width: 600px) {
      margin: 20px 0;
    }
  }
`;

const TypographyWithMarginBot = styled(Typography)`
  && {
    margin-bottom: 1em;
  }
`;

const TermsPage = ({ modalReady = false }) => (
  <PageWrapper>
    <StyledSection style={modalReady ? { padding: 0, margin: 0, boxShadow: 'none' } : {}}>
      {!modalReady && <StyledTitle variant="title">Terms &amp; Conditions</StyledTitle>}
      <Grid container spacing={32}>
        <Grid item xs={12}>
          {paragraphs.map((p, i) => (
            <Typography key={i} gutterBottom>
              {p}
            </Typography>
          ))}
        </Grid>
        <Grid item xs={12}>
          <TypographyWithMarginBot variant="display1">Buyer</TypographyWithMarginBot>
          {buyerTerms.map((term, i) => (
            <React.Fragment key={i}>
              {term.title && <Typography variant="body2">{`${term.title}:`}</Typography>}
              <List disablePadding>
                {term.items.map((item, j) => {
                  if (typeof item === 'string') {
                    return (
                      <ListItem disableGutters dense key={`${i}${j}`}>
                        <Typography>{`- ${item}`}</Typography>
                      </ListItem>
                    );
                  }

                  return <NestedListItem term={item} key={`${i}${j}`} />;
                })}
              </List>
            </React.Fragment>
          ))}
        </Grid>
        <Grid item xs={12}>
          <TypographyWithMarginBot variant="display1">Seller</TypographyWithMarginBot>
          {sellerTerms.map((term, i) => (
            <React.Fragment key={i}>
              {term.title && <Typography variant="body2" gutterBottom>{`${term.title}:`}</Typography>}
              <List disablePadding>
                {term.items.map((item, j) => {
                  if (typeof item === 'string') {
                    return (
                      <ListItem disableGutters dense key={`${i}${j}`}>
                        <Typography>{`- ${item}`}</Typography>
                      </ListItem>
                    );
                  }

                  return <NestedListItem term={item} key={`${i}${j}`} />;
                })}
              </List>
            </React.Fragment>
          ))}
        </Grid>
        <Grid item xs={12}>
          <Typography gutterBottom>
            <span style={{ fontWeight: 700 }}>INDEMNIFICATION:</span> ALL USERS AGREE TO INDEMNIFY, DEFEND, AND HOLD
            HARMLESS AUTOAXESS, ITS SUCCESSORS AND ASSIGNS, AND EACH OF THEIR RESPECTIVE DIRECTORS, OFFICERS, EMPLOYEES,
            MEMBERS, REPRESENTATIVES, VOLUNTEERS, INDEPENDENT CONTRACTORS, AND AGENTS (EACH, ANY AUTOAXESS PARTY" AND
            COLLECTIVELY, THE "AUTOAXESS PARTIES"), FROM AND AGAINST ANY AND ALL CLAIMS, LOSSES, DEMANDS, CAUSES OF
            ACTION, DEBTS, OR LIABILITIES, INCLUDING ATTORNEYS’ FEES, ARISING OUT OF OR RELATING TO: (a) ANY PERSONAL
            INJURY OR PROPERTY DAMAGE THAT YOU MAY CAUSE, EITHER SOLELY BY YOUR OWN ACTIONS OR JOINTLY WITH OTHERS
            (INCLUDING THE AUTOAXESS PARTIES), TO AUTOAXESS, ANY PERSONNEL OR CUSTOMERS OF AUTOAXESS, OR ANY THIRD
            PARTIES, OR THE PROPERTY OF ANY OF THE FOREGOING;
          </Typography>
          <Typography>
            YOU EXPRESSLY WAIVE YOUR ABILITY TO PARTICIPATE IN A CLASS OR REPRESENTATIVE PROCEEDING AGAINST AUTOAXESS.
          </Typography>
          <Typography gutterBottom>
            In the event of any legal action or proceeding arising out of or related to this Agreement, the{' '}
            <span style={{ fontWeight: 500 }}>prevailing party</span> shall be entitled to recover its{' '}
            <span style={{ fontWeight: 500 }}>reasonable attorney's fees, court costs,</span> and other expenses
            incurred in connection with such action or proceeding (including any appeal or enforcement of a judgment),
            in addition to any other relief to which it may be entitled.
          </Typography>
          <Typography gutterBottom>
            This Website shall not be responsible for any items sold by Auction, for any damage to items during transit
            or during the inspection period, nor for misrepresentations and/or breaches of contract by either buyer
            and/or seller. This web-site shall not be responsible for the cost of procurement of substitute goods or any
            losses resulting from any goods purchased or obtained.
          </Typography>
          <Typography gutterBottom>
            This web-site assumes no liability for the content of the listings. However if you fall victim of a
            fraudulent transaction we will assist you as much as we can.
          </Typography>
          <Typography gutterBottom>
            These Terms of Service shall be governed by and constructed in accordance with the laws of the state of
            California and any disputes will be decided only by the Courts of Alameda County, California.
          </Typography>
          <Typography gutterBottom>
            <span style={{ fontWeight: 700 }}>Understanding of Terms of us:</span>{' '}
            <span style={{ fontWeight: 500 }}>
              You acknowledge and agree that you understand these terms and conditions written in English and that you
              have (if needed) sought the help of an attorney and/or translator as you deem necessary to understand
              them. The Parties hereto agree that this agreement, and all correspondence and all documentation relating
              to this agreement, be written in the English language.
            </span>
          </Typography>
          <Typography gutterBottom>
            This Agreement is effective starting on January 1st, 2010, for current users, and upon acceptance for new
            users. Anyone that uses the AutoAxess platform is responsible for these terms of use while using the
            AutoAxess platform and any updates to these Terms and Conditions or terms of use will be displayed for
            buyers and sellers to view at any time. Your use of the site is your agreement to these terms of use and
            AutoAxess reserves the right to change or update these Terms of use at any time to update current business
            practices. This Agreement sets forth the entire understanding and agreement between us with respect to the
            subject matter hereof.
          </Typography>
        </Grid>
      </Grid>
    </StyledSection>
  </PageWrapper>
);

export default TermsPage;

const NestedListItem = ({ term }) => {
  return (
    <React.Fragment>
      <div style={{ height: '8px' }} />
      {term.title && (
        <Typography
          style={{
            minWidth: 'fit-content',
            display: 'inline',
            fontSize: '16px'
          }}
          variant="body2"
        >{`- ${term.title}`}</Typography>
      )}
      {term.description && <Typography style={{ display: 'inline' }}>{` ${term.description}`}</Typography>}

      <ul>
        <List disablePadding>
          {term.items.map((item, j) => (
            <ListItem disableGutters dense key={`${term.title}${j}`}>
              <Typography>{`- ${item}`}</Typography>
            </ListItem>
          ))}
        </List>
      </ul>
      <div style={{ height: '8px' }} />
    </React.Fragment>
  );
};
